import React from "react";
import CustomRow from "../../shared/costum-row/costum-row";
import { Col, Typography } from "antd";

import "./styles.scss";

const { Title, Text } = Typography;

type HomeHeadlineType = {
  title: string;
  subtitle: string;
};

const HomeHeadline = ({ title, subtitle }: HomeHeadlineType) => {
  return (
    <CustomRow
      className="HomeHeadline"
      justify="space-between"
      align="bottom"
      gutter={[0, 32]}
    >
      <Col xxl={5} xl={5} lg={6} md={6} sm={24} xs={24}>
        <Title className="HomeHeadline-title">{title}</Title>
      </Col>
      <Col xxl={12} xl={12} lg={15} md={15} sm={24} xs={24}>
        <Text className="HomeHeadline-subtitle">{subtitle}</Text>
      </Col>
    </CustomRow>
  );
};

export default HomeHeadline;
